import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router";
import {
  useFetchAuthorisation,
  authorisationConverter,
  useFetchUserData,
} from "../../utils/AppFunctions";
import config from "../../app-config";
import "react-toastify/dist/ReactToastify.css";
import AdminLayout from "../../layouts/AdminLayout";
import { create_new_mobile_campaign, delete_mobile_campaign, fetch_all_contact_groups, fetch_all_mobile_campaigns, fetch_contact_group_by_id, fetch_mobile_campaign_by_id, update_mobile_campaign_by_mobile_campaign_id } from "../../api/campaignsAPI";
import notify from "../../utils/IANotification";
import { captialise_first_letter, tidy_date } from "../../utils/helper";
import { MdAdd, MdCheck } from "react-icons/md";
import DataTable from "../../components/ui/DataTable";
import Switch from 'react-switch'
import Select from 'react-select'

export default function CampaignPushFormPage() {
  const navigate = useNavigate();
  let user_data = useFetchUserData();
  let campaign_id = new URLSearchParams(window.location.search).get("campaign_id");
  const [campaignData, setCampaignData] = useState({
    title: "",
    description: "",
    scheduled_datetime: "",
    status: "",
    is_everyone: 0,
    group_ids: [],
  })
  const [loading, setLoading] = useState(true)
  const [groupData, setGroupData] = useState([])

  const fetchCampaignGroupById = async () => {
    setLoading(true)
    const { data, error, message, status } = await fetch_all_contact_groups()
    if (error) notify({ message: message || error, type: 'error' })
    setGroupData(data)
    setLoading(false)
  }

  useEffect(() => {
    fetchCampaignById()
    fetchCampaignGroupById()
  }, [])

  const fetchCampaignById = async () => {
    if (!campaign_id || campaign_id === "new") return
    setLoading(true)
    const { data, error, message, status } = await fetch_mobile_campaign_by_id(campaign_id)
    if (error) notify({ message: message || error, type: 'error' })
    setCampaignData(data)
    setLoading(false)
  }

  const createNewCampaign = async (options) => {
    const { data, error, message, status } = await create_new_mobile_campaign({ ...campaignData, ...options })
    if (error) notify({ message: message || error, type: 'error' })
    notify({ message: "Campaign created successfully", type: 'success' })
    navigate(`/admin/campaigns/push/details?campaign_id=${data?.id}`)
  }

  const updateCampaignById = async (options) => {
    if (!campaign_id) return
    const { data, error, message, status } = await update_mobile_campaign_by_mobile_campaign_id(campaign_id, { ...campaignData, ...options })
    if (error) notify({ message: message || error, type: 'error' })
    notify({ message: "Campaign updated successfully", type: 'success' })
    fetchCampaignById()
  }

  const deleteCampaignById = async () => {
    if (!campaign_id) return
    const { data, error, message, status } = await delete_mobile_campaign(campaign_id)
    if (error) notify({ message: message || error, type: 'error' })
    notify({ message: "Campaign deleted successfully", type: 'success' })
    navigate(`/admin/campaigns/push`)
  }

  const selectOptions = [
    { value: 'draft', label: 'Draft' },
    { value: 'scheduled', label: 'Schedule' },
  ]

  return (
    <AdminLayout navSelected={"Push Notification"}
      toolbar={
        <>
          <h1 className="text-2xl font-bold text-gray-900">
            {campaign_id === "new" ? "Create Push Campaign" : "Edit Push Campaign"}
          </h1>
          <div className="flex gap-2">
            {campaign_id !== "new" && (
              <button 
                className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors"
                onClick={deleteCampaignById}
              >
                Delete
              </button>
            )}
            <button 
              className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
              onClick={() => {
                if (campaign_id === "new") {
                  createNewCampaign({ trigger_now: 0 })
                } else {
                  updateCampaignById({ trigger_now: 0 })
                }
              }}
            >
              {campaign_id === "new" ? "Create" : "Save"}
            </button>
            {(
              <button 
                className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors"
                onClick={() => {
                  createNewCampaign({ trigger_now: 1 })
                }}
              >
                Send Now
              </button>
            )}
          </div>
        </>
      }
    >
      <div className="w-full">
        <div className="card mb-2">
          <p className="card-title">Campaign Details</p>
          <div className="input-container">
            <label htmlFor="title" className="input-label">Title</label>
            <input type="text" id="title" className="text-input"
              value={campaignData.title}
              onChange={(e) => setCampaignData({ ...campaignData, title: e.target.value })}
              placeholder="e.g. Welcome to Bedok Methodist Church"
            />
          </div>
          <div className="input-container">
            <label htmlFor="description" className="input-label">Description</label>
            <textarea id="description" className="textarea-input"
              value={campaignData.description}
              onChange={(e) => setCampaignData({ ...campaignData, description: e.target.value })}
              placeholder="e.g. This is a description for the campaign"
            />
          </div>

        </div>
        <div className="card mb-2">
          <p className="card-title">Schedule</p>
          <div className="input-container">
            <label htmlFor="scheduled_datetime" className="input-label">Scheduled Date & Time</label>
            <input type="datetime-local" id="scheduled_datetime" className="text-input" value={campaignData.scheduled_datetime} onChange={(e) => setCampaignData({ ...campaignData, scheduled_datetime: e.target.value })} />
          </div>
          <div className="input-container">
            <label htmlFor="status" className="input-label">Status</label>
            <Select
              id="status"
              className="react-select"
              options={selectOptions}
              value={selectOptions.find(option => option.value === campaignData.status)}
              onChange={(selectedOption) => setCampaignData({ ...campaignData, status: selectedOption.value })}
            />
          </div>
          <div className="flex flex-row items-center py-2 gap-2">
            <Switch
              label="Broadcast"
              checked={campaignData.is_everyone}
              onChange={(checked) => setCampaignData({ ...campaignData, is_everyone: checked ? 1 : 0 })}
            />
            <label htmlFor="" className="input-label">Broadcast</label>
          </div>
          {campaignData?.is_everyone == 0 && <div className="input-container">
            <label htmlFor="description" className="input-label">Groups</label>
            <div className="flex flex-row items-center gap-2">
              <Select
                options={groupData.map(group => ({ value: group.id, label: group.name }))}
                isMulti
                styles={{ container: (base) => ({ ...base, width: "100%" }) }}
                onChange={(selected) => setCampaignData({ ...campaignData, group_ids: selected.map(s => s.value) })}
                value={groupData.filter(group => campaignData.group_ids.includes(group.id)).map(group => ({ value: group.id, label: group.name }))}
              />
            </div>
          </div>}
        </div>
      </div>
    </AdminLayout>
  )
}